import { cloneDeep } from 'lodash';

import {
    ADD_REPORT,
    CHANGE_REPORTS_COLUMNS_VISIBILITY,
    CHANGE_REPORTS_GRID_ORDER,
    FETCH_REPORTS,
    ReportsClientAction,
    SHOW_REPORTS_GENERAL_ERROR,
    STOP_REPORTS_LOADING,
    UPDATE_COLUMNS_SETTINGS_REPORTS_STATE,
    UPDATE_REPORTS,
    UPDATE_REPORTS_COLUMNS_WIDTH
} from '../actions/reportsClient';
import { getColumnsSettings } from '../declarations/common';
import { reportsClient } from '../typings/common';
import { ReportsClientState, State } from '../typings/state';

export const ReportsInitialState: ReportsClientState = {
    columnsSettings: getColumnsSettings(),
    loading: false
};

export function reportClient(
    state: ReportsClientState = ReportsInitialState,
    action: ReportsClientAction,
    fullState: State
): ReportsClientState {
    switch (action.type) {
        case FETCH_REPORTS:
            return {
                ...state,
                loading: true,
                login: action.login
            };
        case UPDATE_REPORTS:
            return {
                ...state,
                reportsClient: cloneDeep(action.reports),
                loading: false
            };
        case ADD_REPORT:
            return {
                ...state,
                periodValue: action.period,
                loading: true
            };
        case UPDATE_REPORTS_COLUMNS_WIDTH:
            return {
                ...state,
                columnsSettings: cloneDeep(action.columns)
            };
        case CHANGE_REPORTS_GRID_ORDER:
            return {
                ...state,
                columnsSettings: {
                    ...state.columnsSettings,
                    [reportsClient]: {
                        ...state.columnsSettings[reportsClient],
                        columnOrder: action.columnOrder
                    }
                }
            };
        case CHANGE_REPORTS_COLUMNS_VISIBILITY:
            return {
                ...state,
                columnsSettings: cloneDeep(action.columns)
            };
        case SHOW_REPORTS_GENERAL_ERROR:
            return {
                ...state,
                loading: false,
                errorLoadData: action.error
            };
        case STOP_REPORTS_LOADING:
            return {
                ...state,
                loading: false
            };
        case UPDATE_COLUMNS_SETTINGS_REPORTS_STATE:
            return {
                ...state,
                columnsSettings: cloneDeep(action.columnsSettings)
            };
        default:
            return state;
    }
}
